
import { join } from 'lodash-es'
import { Component, Vue, Watch } from 'vue-property-decorator'
import Header from '~/components/common/header/Header.vue'
import Subheader from '~/components/common/header/Subheader.vue'
import PreLoader from '~/components/common/loader/pre-loader/PreLoader.vue'
import AutoApplicationModalProvider from '~/components/common/modals/auto-application-modal/AutoApplicationModalProvider.vue'
import WinnerModal from '~/components/common/modals/WinnerModal.vue'
import { APPLICATION_LIST, SCHOLARSHIP_LIST } from '~/store/cardList'
import ReferralModalProvider from '~/components/common/ReferralModalProvider.vue'

@Component({
  name: 'DashboardLayout',
  components: {
    Subheader,
    Header,
    PreLoader,
    AutoApplicationModalProvider,
    WinnerModal,
    ReferralModalProvider
  }
})
export default class DashboardLayout extends Vue {
  created() {
    if (!this.$auth.loggedIn && !this.$config.useExternalLoginUi) {
      this.$modal.show(Vue.component('ModalAuthentication'), {
        success: () => this.$accessor.initStore(this.$config),
        close: () => (window.location.href = '/')
      })
    }
  }

  get scholarshipListDeps() {
    const { freemium } = this.$auth.user?.membership || {}
    const { isExpectingRecommendationsToExist } = this.$accessor.recommendation
    return join([
      freemium,
      isExpectingRecommendationsToExist
    ], '|')
  }

  get applicationListDeps() {
    const freemium = this.$auth.user?.membership?.freemium
    // Only track submitted route for users without active membership
    const needsSubmittedRouteTracking = !this.$auth.user?.membership && this.$accessor.account.isSubmittedScholarshipsRoute
    return join([freemium, needsSubmittedRouteTracking ? 'submitted' : ''], '|')
  }

  get recommendedListDeps() {
    const { freemium } = this.$auth.user?.membership || {}
    const { isExpectingRecommendationsToExist } = this.$accessor.recommendation
    const { recentlyIgnoredScholarshipId } = this.$accessor.tabList
    return join([
      freemium,
      isExpectingRecommendationsToExist,
      recentlyIgnoredScholarshipId
    ], '|')
  }

  @Watch('scholarshipListDeps')
  refetchScholarships() {
    this.$accessor.cardList.fetchList({ storeName: SCHOLARSHIP_LIST })
  }

  @Watch('applicationListDeps')
  refetchApplications() {
    this.$accessor.cardList.fetchList({ storeName: APPLICATION_LIST })
  }

  @Watch('recommendedListDeps')
  refetchRecommendations() {
    const {
      fetchRecommendedScholarships,
      isExpectingRecommendationsToExist
    } = this.$accessor.recommendation || {}
    if (isExpectingRecommendationsToExist) {
      fetchRecommendedScholarships({ isForced: true })
    }
  }
}
